// components/ProductList.js
import React, { useState } from 'react';
import ProductCard from './ProductCard';
import productsData from '../data/products';
import Filter from './Filter';
import '../styles/productList.css';

function ProductList() {
  const [filters, setFilters] = useState({
    category: '',
    price: '',
    rating: ''
  });

  const filteredProducts = productsData.filter(product => {
    const matchCategory = filters.category ? product.category === filters.category : true;
    const matchPrice = filters.price ? (
      product.price >= Number(filters.price.split('-')[0]) &&
      product.price <= Number(filters.price.split('-')[1])
    ) : true;
    const matchRating = filters.rating ? product.rating >= Number(filters.rating) : true;

    return matchCategory && matchPrice && matchRating;
  });

  return (
    <div className="product-list">
      <h1>Our Products</h1>
      <Filter filters={filters} setFilters={setFilters} />
      <div className="product-grid">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
        {filteredProducts.length === 0 && <p>No products match your filter.</p>}
      </div>
    </div>
  );
}

export default ProductList;
